import { useState } from 'react';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { CmmConfigs } from './cmm-configs/cmmConfigs.tsx';
import { CncCoordinates } from './cnc-oordinates/cncCoordinates.tsx';
import { CncSignals } from './cnc-signals/cncSignals.tsx';
import { CustomEquipments } from './custom-equipments/customEquipments.tsx';
import { Customers } from './customers/customers.tsx';
import { GlobalSequenceReset } from './global-sequence-reset/globalSequenceReset.tsx';
import { Operators } from './operators/operators.tsx';

const resourceSections = [
    { key: 'operators', label: 'Operators', Component: Operators },
    { key: 'custom-equipments', label: 'Custom equipments', Component: CustomEquipments },
    { key: 'customers', label: 'Customers', Component: Customers },
    { key: 'cnc-coordinates', label: 'Equipment coordinates', Component: CncCoordinates },
    { key: 'cnc-signals', label: 'Equipment signals', Component: CncSignals },
    { key: 'cmm-configs', label: 'CMM configs', Component: CmmConfigs },
    { key: 'sequence-reset', label: 'Measurement sequence reset', Component: GlobalSequenceReset },
] as const;

type ResourceSectionKey = typeof resourceSections[number]['key'];


export function Resources() {
    const [selectedSectionKey, setSelectedSectionKey] = useState<ResourceSectionKey>('operators');
    const selectedSection = resourceSections.find((section) => section.key === selectedSectionKey) ?? resourceSections[0];
    const SelectedResource = selectedSection.Component;

    return (
        <>
            <PageTitle title='Resources' />
            <NavBar />
            <div
                className='content'
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '0px',
                    paddingBottom: '20px',
                }}
            >
                <div className='resources__settings_bar'>
                    <div className='resources__nav' role='tablist' aria-label='Resource sections'>
                        {resourceSections.map((section) => (
                            <button
                                key={section.key}
                                type='button'
                                role='tab'
                                aria-selected={selectedSectionKey === section.key}
                                className={`resources__nav_button${selectedSectionKey === section.key ? ' resources__nav_button--active' : ''}`}
                                onClick={() => setSelectedSectionKey(section.key)}
                            >
                                {section.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div className='resources__content'>
                    <SelectedResource />
                </div>
            </div>
        </>
    );
}
